<!--APP-SIDEBAR-->
<div class="app-sidebar__overlay" (click)="sidebarClose()"></div>
<!-- Sidemenu -->
<div class="app-sidebar sticky" [ngClass]="{ 'fixed-header visible-title': scrolled }">
  <div class="side-header">
    <a class="header-brand1" routerLink="/dashboard">
      <img src="./assets/images/logos/light-logo.svg" class="header-brand-img desktop-logo" alt="Logo">
      <img src="./assets/images/logos/light-logo.svg" class="header-brand-img toggle-logo" alt="Logo">
      <img src="./assets/images/logos/light-logo.svg" class="header-brand-img light-logo" alt="Logo">
      <img src="./assets/images/logos/light-logo.svg" class="header-brand-img light-logo1" alt="Logo">
    </a>
  </div>
  <ng-scrollbar>
    <div class="main-sidemenu">
      <!-- left-arrow -->
      <div class="slide-left disabled" id="slide-left"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
      <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" /></svg>
    </div>
    <div class="slide-leftRTL disabled" id="slide-leftRTL"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
    <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" /></svg>
  </div>
  <ul class="side-menu">
    <!-- 1st Level Menu -->
    @for (menuItem of menuItems; track menuItem) {
      <li [ngClass]="{'':menuItem.headTitle,'slide':menuItem.title, 'active': menuItem.active, 'is-expanded': menuItem.active}">
        @if (menuItem.headTitle) {
          <h3>{{menuItem.headTitle | translate}}</h3>
        }
        <!-- has-Link -->
        @if (menuItem.type === 'link' ) {
          <a class="side-menu__item has__link" [routerLink]="!menuItem.type ? null : [menuItem.path]"
            routerLinkActive="active" (click)="toggleNavActive(menuItem)">
            <span class="shape1"></span>
            <span class="shape2"></span>
            <span class="side-menu__icon">
              <lucide-icon [name]="menuItem.icon" size="18"></lucide-icon>
            </span>
            <span class="side-menu__label">{{menuItem.title | translate}}</span>
          </a>
        }
        <!-- empty path -->
        @if (menuItem.type === 'empty') {
          <a class="side-menu__item has__link" href="javascript:;" routerLinkActive="active"
            (click)="toggleNavActive(menuItem)">
            <span class="shape1"></span>
            <span class="shape2"></span>
            <span class="side-menu__icon">
              <lucide-icon [name]="menuItem.icon" size="18"></lucide-icon>
            </span>
            <span class="side-menu__label">{{menuItem.title | translate}}</span>
          </a>
        }
        <!-- external -->
        @if (menuItem.type === 'external' ) {
          <a class="side-menu__item has__link" routerLinkActive="active" target="_blank"
            [routerLink]="!menuItem.type ? null : [menuItem.path] "
            (click)="toggleNavActive(menuItem)">
            <span class="side-menu__icon">
              <lucide-icon [name]="menuItem.icon" size="18"></lucide-icon>
            </span>
            <span class="side-menu__label">{{menuItem.title | translate}}</span>
            <span class="badge badge-sm bg-{{menuItem.badgeClass}} badge-hide">{{menuItem.badgeValue}}</span>
          </a>
        }
        <!-- has-Sub -->
        @if (menuItem.type === 'sub') {
          <a class="side-menu__item" [routerLink]="menuItem.type ? null: [menuItem.path]"
            (click)="toggleNavActive(menuItem)" [ngClass]="{'active': menuItem.active}">
            <span class="shape1"></span>
            <span class="shape2"></span>
            <span class="side-menu__icon">
              <lucide-icon [name]="menuItem.icon" size="18"></lucide-icon>
            </span>
            <span class="side-menu__label">{{menuItem.title | translate}}</span>
            @if (menuItem.badgeClass && menuItem.badgeValue) {
              <span class="{{menuItem.badgeClass}}">
                {{menuItem.badgeValue}}
              </span>
            }
            <lucide-icon name="chevron-right" size="14" class="angle" [ngClass]="{ 'd-none': menuItem.badgeClass}"></lucide-icon>
          </a>
        }
        <!-- 2nd Level menu -->
        @if (menuItem.children) {
          <ul class="slide-menu" [ngClass]="{'open': menuItem.active}">
            @for (childrenItem of menuItem.children; track childrenItem) {
              <li
                [ngClass]="{'is-expanded active': childrenItem.active, 'sub-slide': childrenItem.Menusub}">
                <!-- link -->
                @if (childrenItem.type === 'link' ) {
                  <a class="slide-item" routerLinkActive="active"
                    [routerLink]="!childrenItem.type ? null : [childrenItem.path] "
                    (click)="toggleNavActive(childrenItem)">
                    {{childrenItem.title | translate}}
                  </a>
                }
                <!-- empty -->
                @if (childrenItem.type === 'empty' ) {
                  <a class="slide-item" routerLinkActive="active" href="javascript:;"
                    (click)="toggleNavActive(childrenItem)">
                    {{childrenItem.title | translate}}
                  </a>
                }
                <!-- sub -->
                @if (childrenItem.type === 'sub' ) {
                  <a href="javascript:;" class="sub-side-menu__item"
                    [routerLink]="childrenItem.type ? null : [childrenItem.path]"
                    (click)="toggleNavActive(childrenItem)">
                    <span class="sub-side-menu__label"> {{childrenItem.title | translate}}</span>
                    <lucide-icon name="chevron-right" size="14" class="sub-angle"></lucide-icon>
                  </a>
                }
                <!-- 3rd Level menu -->
                @if (childrenItem.children) {
                  <ul class="sub-slide-menu" [ngClass]="{'open': childrenItem.active}"
                    [ngClass]="{'open': childrenItem.active}">
                    @for (childrenSubItem of childrenItem.children; track childrenSubItem) {
                      <li [ngClass]="{'is-expanded': childrenSubItem.active}">
                        <!-- link -->
                        @if (childrenSubItem.type === 'link') {
                          <a class="sub-slide-item" routerLinkActive="active"
                            [routerLink]="!childrenSubItem.type ? null : [childrenSubItem.path]"
                            (click)="toggleNavActive(childrenSubItem)">
                            {{childrenSubItem.title | translate}}
                          </a>
                        }
                        <!-- empty -->
                        @if (childrenSubItem.type === 'empty') {
                          <a class="sub-slide-item" href="javascript:;"
                            (click)="toggleNavActive(childrenSubItem)">
                            {{childrenSubItem.title | translate}}
                          </a>
                        }
                        <!-- sub -->
                        @if (childrenSubItem.type === 'sub' ) {
                          <a class="sub-slide-item" href="javascript:;"
                            [routerLink]="childrenSubItem.type ? null : [childrenItem.path]"
                            (click)="toggleNavActive(childrenSubItem)">
                            <span class="sub-side-menu__label2"> {{childrenSubItem.title | translate}} </span>
                            <lucide-icon name="chevron-right" size="14" class="sub-angle2"></lucide-icon>
                          </a>
                        }
                        <!--4th level -->
                        @if (childrenSubItem.children) {
                          <ul class="sub-slide-menu2"
                            [ngClass]="{'open': childrenSubItem.active}">
                            @for (childrenSubItem1 of childrenSubItem.children; track childrenSubItem1) {
                              <li class=" "
                                [ngClass]="{'is-expanded': childrenSubItem1.active}">
                                @if (childrenSubItem1.type === 'link') {
                                  <a class="sub-slide-item2" routerLinkActive="active"
                                    [routerLink]="!childrenSubItem1.type ? null : [childrenSubItem1.path]"
                                    >
                                  {{childrenSubItem1.title | translate}}</a>
                                }
                              </li>
                            }
                          </ul>
                        }
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
  <!-- Bloc d'aide moderne -->
  <div class="help-container">
    <hr>
      @for (menuItem of menuItems; track menuItem) {
        <div>
          @if (menuItem.type === 'help') {
            <div class="help-block">
              <img src="assets/images/svgs/help-folder.svg" alt="Help" class="help-img" />
              <div class="help-title mt-3 mb-1" style="font-size: 1.2em; font-weight: bold; color: var(--accent-color);">{{'Besoin d\'aide ?' | translate}}</div>
              <div class="help-subtitle mb-3" style="color: #6c757d;">{{'support@skytechsystems.io'  | translate}}</div>
              <button class="help-btn --accent-color" (click)="openMail()">
                {{ 'nous contacter' | translate }}
              </button>
            </div>
          }
        </div>
      }
    </div>
    <!-- right-arrow  -->
    <div class="slide-right" id="slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
    <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" /></svg>
  </div>
  <div class="slide-rightRTL" id="slide-rightRTL"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
  <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" /></svg>
</div>
</div>
</ng-scrollbar>
</div>
<!-- End Sidemenu -->
